//@ts-nocheck

import styled, { css } from 'styled-components'
import { ButtonLabel } from '../../atoms/Typography/Typography.styles'
import { StyledButton } from '../../atoms/Button/Button.styles'

export const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: ${({ theme }) => theme.layers.header};
  transition: transform .2s ease-in .2s;

  ${({ theme, scrollDirection }) => scrollDirection === 'down' && theme.mediaQuery.md(`
    transform: translateY(${theme.rem(-46)});
  `)}

  ${({ theme, scrollDirection }) => scrollDirection === 'up' && theme.mediaQuery.md(`
    transition: transform .1s linear 0s;
  `)}
`

export const PreHeader = styled.div`
  min-height: ${({ theme }) => theme.rem(46)};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.rem(0, 40)};
  gap: ${({ theme }) => theme.rem(40)};
  background-color: #EFEFEF;
  z-index: 11;

  ${({ theme }) => theme.mediaQuery.lg(`
    padding-right: ${theme.rem(80)};
    justify-content: flex-end;
  `)}
`

export const PreHeaderMenu = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  ${StyledButton} {
    padding: ${({ theme }) => theme.rem(3)};
  }

  ${ButtonLabel} {
    font-size: ${({ theme }) => theme.rem(14)};
  }

  i {
    font-size: ${({ theme }) => theme.rem(16)};
    margin-right: ${({ theme }) => theme.rem(8)}!important;
    margin-left: 0!important;
  }
`

export const PreHeaderMenuLeftSide = styled.div`
  margin-right: auto;

  span {
    font-size: ${({ theme }) => theme.rem(14)};
  }
`

export const Header = styled.header`
  width: 100%;
  height: ${({ theme }) => theme.rem(72)};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0;
  padding: ${({ theme }) => theme.rem(0, 16)};
  background-color: white;
  border-bottom: 1px solid gray;
  z-index: ${({ theme }) => theme.layers.header};

  ${({ theme }) => theme.mediaQuery.lg(`
    position: sticky;
    height: ${theme.rem(68)};
    gap: ${theme.rem(80)};
    padding: ${theme.rem(0, 40)};
  `)}
`

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  /* gap: ${({ theme }) => theme.rem(16)}; */

  ${({ theme }) => theme.mediaQuery.sm(`
    gap: ${theme.rem(40)};
  `)}
`

export const HeaderRight = styled.div`
  display: none;
  align-items: center;
  gap: ${({ theme }) => theme.rem(40)};

  ${({ theme }) => theme.mediaQuery.lg(`
    display: flex;
  `)}
`

export const HeaderMenuButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.rem(4)};
  padding: ${({ theme }) => theme.rem(8, 32)};
  background-color: transparent;
  color: black;
  border-radius: ${({ theme }) => theme.rem(4)};
  border: 0;
  outline: 2px solid transparent;
  outline-offset: 2px;
  cursor: pointer;
  transition: outline 0.3s ease-in-out;

  &:focus-visible {
    outline-color: black;
  }
`

export const HeaderMenu = styled.div`
  display: flex;
  align-items: center;
  padding-right: ${({ theme }) => theme.rem(40)};
  gap: ${({ theme }) => theme.rem(8)};
`

export const HeaderMenuIcons = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.rem(16)};
`

export const HeaderLogo = styled.a`
  display: flex;

  > i {
    font-size: ${({ theme }) => theme.rem(24)};
  }
`

export const MenuOverlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: ${({ theme }) => theme.layers.overlay};
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  ${({ isOpen }) => isOpen && css`
    visibility: visible;
    opacity: 1;
  `}

  ${({ scrollDirection }) => scrollDirection === 'down' && css`
    height: 120svh;
  `}
`

export const HeaderMenuButtonWrapper = styled.div`
  cursor: pointer;
`